import React from 'react';
import employeeShape from 'shapes/employee';
import { I18n } from 'utils/i18n';
import CopyButton from './CopyButton';

const InviteLink = ({ employee }) => (
  <CopyButton value={employee.magicLink} text={I18n.t('ProfileDrawer.Copy invite link')} />
);

InviteLink.propTypes = {
  employee: employeeShape.isRequired,
};

export default InviteLink;
